import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col, Image, Spinner } from "react-bootstrap";
import blogService from "../services/blogService";
import BackButton from "../routes/BackButton";
const BlogDetail = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const handleBackClick = () => {
    window.history.back();
  };
  useEffect(() => {
    const fetchBlogDetail = async () => {
      try {
        setIsLoading(true);
        const blogDetail = await blogService.getBlogById(id);
        setBlog(blogDetail);
      } catch (error) {
        console.error("Error fetching blog detail:", error);
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchBlogDetail();
  }, [id]);

  if (isLoading) {
    return (
      <Container className="text-center my-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="text-center my-5">
        <h2>Error</h2>
        <p>{error}</p>
      </Container>
    );
  }

  if (!blog) {
    return (
      <Container className="text-center my-5">
        <h2>Blog Not Found</h2>
      </Container>
    );
  }

  return (
    <Container className="my-5 blog-detail" style={{ fontFamily: "'Hanuman', Arial, sans-serif" }}>
      <Row>
        <Col md={8} className="mx-auto blog mt-5">
          <div>
            <BackButton onClick={handleBackClick} />
          </div>
          <h1 className="mb-4 mt-4">{blog.title}</h1>
          <div className="mb-4 w-100 d-flex justify-content-center align-items-center">
            <Image
              src={blog.image}
              fluid
              rounded
              className="blogdetail-image-size img-fluid"
            />
          </div>
          <div className="blog-meta mb-4">
            <p>
              <strong>Date:{blog.date}</strong>{" "}
            </p>
          </div>
          <div
            className="blog-content"
            dangerouslySetInnerHTML={{ __html: blog.description }}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default BlogDetail;

//correct with 92
